import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem"
import Button from '@mui/material/Button';
import { TableContainer } from "@mui/material";
import { useTheme } from '@mui/material/styles'
import { useState, useEffect } from "react";

const isValidUrl = (value) => {
  try {
    new URL(value.startsWith("http") ? value : `https://${value}`);
    return true;
  } catch {
    return false;
  }
};
const QuestionGrid = ({ data, question, handleChange, qNo, index }) => {

  const { text, title, subtitle, type, doctype } = question;
  const theme = useTheme();
  const [checkValue, setCheckValue] = useState("0");
  const [links, setLinks] = useState([]);
  const [linkErrors, setLinkErrors] = useState([]);
  const [DocTypeValue, setDocTypeValue] = useState("");


  let skipped = false;

  // Only for Q1P2
  if (qNo === "Q1P2") {
    const q1Answered = data.Q1P2?.[0] !== "";
    const q2Answered = data.Q1P2?.[1] !== "";

    skipped =
      (index === 1 && q1Answered && !q2Answered) ||
      (index === 0 && q2Answered && !q1Answered);
  }


  const STYLES = {
    "griddy": {
      display: 'flex', justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
         marginLeft: '25px'
      }
    },
    "boxalign": {
      textAlign: "right",
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      }
    },
    "container": {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display:'block', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', height:'50px', flexWrap: 'nowrap', overflowY: "hidden", 
      }
    },
    "griditem": {
      [theme.breakpoints.down('sm')]: {
        display: 'flex', justifyContent: 'center'
      }
    },
    "gridquestion": {
      pb: 1,  my: 2, pr: 2, alignItems: 'flex-end', justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        pr: 0, 
      }
    },
    "desktop": {
      display: 'flex', justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      }
    }
  }

  const addLink = () => {
  setLinks(prev => [...prev, ""]);
  setLinkErrors(prev => [...prev, false]);
};

const updateLink = (idx, value) => {
  const newLinks = [...links];
  newLinks[idx] = value;

  const newErrors = [...linkErrors];
  newErrors[idx] = false;

  setLinks(newLinks);
  setLinkErrors(newErrors);
};

const removeLink = (idx) => {
  setLinks(prev => prev.filter((_, i) => i !== idx));
  setLinkErrors(prev => prev.filter((_, i) => i !== idx));
};

const validateAndSaveLinks = () => {
  let hasError = false;
  const errors = links.map(link => {
    if (!isValidUrl(link)) {
      hasError = true;
      return true;
    }
    return false;
  });

  setLinkErrors(errors);

  if (!hasError) {
    handleChange(
      { target: { value: links.map(l => l.trim()) } },
      qNo,
      index
    );
  }
};

  const renderQuestionLabel = () => {
    const prefix = `${index + 1}. `;

    // Old questions (single line)
    if (text) {
      return (
        <FormLabel>
          <strong>{prefix}</strong>
          {text}
        </FormLabel>
      );
    }
    // New questions (2 lines)
    return (
      <>
<Grid item xs={12} sx={{ my: 3 }}>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    {/* ROW 1: Question */}
    <FormLabel sx={{ fontWeight: 500 }}>
      <strong>{prefix}</strong>
      {title}
    </FormLabel>
      {subtitle && (
        <Box
          sx={{
            ml: 3,
            fontSize: "0.85rem",
            color: "text.secondary",
            fontStyle: "italic",
          }}
        >
          {subtitle}
        </Box>
      )}

  </Box>
</Grid>


      </>
      
    );

  };

 return (
    <Grid container spacing={2}>
      {/* ================= REMARKS ================= */}
      {type.match(/remarks/) && (
        <Grid item xs={12} sx={{ my: 3 }}>
          {renderQuestionLabel()}
          <TextField
            multiline
            minRows={3}
            //maxRows={10}
            fullWidth
            placeholder="Enter remarks here…"
            onBlur={(ev) => handleChange(ev, qNo, index)}
            sx={{
              mt: 1.5,
              '& textarea': {
                resize: 'vertical'
              }
            }}
          />
        </Grid>
      )}

      {/* ================= NOTES ================= */}
      {type.match(/notes/) && (
        <Grid item xs={12} sx={{ my: 2 }}>
          {renderQuestionLabel()}
            <TextField
              multiline
              minRows={2}
              fullWidth
              onBlur={(ev) => handleChange(ev, qNo, index)}
              sx={{
                '& textarea': {
                  resize: 'vertical'
                }
              }}
            />
        </Grid>
      )}

      {/* ================= FALLBACK LABEL ================= */}
      {!type.match(/remarks|notes|checkLink/) && (
        <Grid
          item
          xs={12}
          sm={8}
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
          sx={STYLES.gridquestion}
        >
          <Box sx={STYLES.boxalign}>{renderQuestionLabel()}</Box>
        </Grid>
      )}

      {/* ================= CHECK ================= */}
      {type.match(/^check$/) && (
        <>
          <Grid item xs={12} sm={4} display="flex" alignItems="center">
            {skipped ? (
              <Box
                sx={{
                  p: 1.5,
                  border: "1px solid",
                  borderColor: "info.light",
                  bgcolor: "info.lighter",
                  borderRadius: 1,
                  color: "info.main",
                  fontSize: "0.875rem",
                }}
              >
                {index === 1
                  ? "Skipped because Question 1 has been answered. Please proceed to Question 3."
                  : "Skipped because Question 2 has been answered. Please proceed to Question 3."}
              </Box>
            ) : (
              <>
                <RadioGroup
                  row
                  name={`radio-${qNo}-${index}`}
                  value={data[qNo]?.[index] ?? ""}
                  onChange={(ev) => handleChange(ev, qNo, index)}
                >
                  <FormControlLabel value="1" control={<Radio />} label="Yes" />
                  <FormControlLabel value="0" control={<Radio />} label="No" />
                </RadioGroup>

                {data[qNo]?.[index] !== "" && (
                  <Button
                    size="small"
                    variant="text"
                    sx={{ ml: 1 }}
                    onClick={() =>
                      handleChange(
                        {
                          target: {
                            value: "",
                          },
                        },
                        qNo,
                        index
                      )
                    }
                  >
                    Clear
                  </Button>
                )}
              </>
            )}
          </Grid>
        </>
      )}

      {type.match(/^checkLink$/) && (
        <Grid item xs={12}>
          {/* QUESTION + BOX TOGETHER */}
          <Box sx={{ maxWidth: 720, mx: "auto", }}>
            {/* QUESTION */}
            <Box sx={{ mb: 1 }}>
              {renderQuestionLabel()}
            </Box>

            {/* ANSWER BOX */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                p: 2,
              }}
            >
              {/* YES / NO */}
              <RadioGroup
                row
                value={checkValue}
                onChange={(ev) => {
                  const val = ev.target.value;
                  setCheckValue(val);

                  if (val === "0") {
                    setLinks([]);
                    setLinkErrors([]);
                    handleChange({ target: { value: "0" } }, qNo, index);
                  }
                }}
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>

              {checkValue === "1" && (
                <>
                  <Box sx={{ mt: 1 }}>
                    <TextField
                      multiline
                      minRows={3}
                      fullWidth
                      size="small"
                      label="Remarks"
                      placeholder="Remarks"
                      onBlur={(ev) => handleChange(ev, "Doc", index)}
                      sx={{
                        '& textarea': {
                          resize: 'vertical'
                        }
                      }}
                    />
                  </Box>

                  <Box sx={{ mt: 2 }}>
                    {links.map((link, i) => (
                      <TextField
                        key={i}
                        fullWidth
                        size="small"
                        required
                        label={`Link ${i + 1}`}
                        value={link}
                        error={linkErrors[i]}
                        helperText={linkErrors[i] ? "Invalid URL" : ""}
                        sx={{ mb: 1 }}
                        onChange={(ev) => updateLink(i, ev.target.value)}
                        onBlur={validateAndSaveLinks}
                      />
                    ))}

                    <Button
                      variant="contained"
                      size="small"
                      sx={{ mt: 1 }}
                      onClick={addLink}
                    >
                      + Add link
                    </Button>
                  </Box>
                </>
              )}

            </Box>
          </Box>
        </Grid>
      )}



      {/* ================= RISK ================= */}
      {type.match(/risk/) && (
        <>
          <Grid item xs={12} sx={STYLES.container}>
            {["l", "m", "h"].map((level) => (
              <Select
                key={level}
                value={data[qNo][index] || ""}
                onChange={(ev) => handleChange(ev, qNo, index)}
              >
                <MenuItem value="">Clear</MenuItem>
                <MenuItem value={`${level}-yes`}>Yes</MenuItem>
                <MenuItem value={`${level}-no`}>No</MenuItem>
                <MenuItem value={`${level}-na`}>NA</MenuItem>
              </Select>
            ))}
          </Grid>

          {["l", "m", "h"].map((level) => (
            <Grid
              item
              xs={1}
              key={level}
              display="flex"
              alignItems="center"
              sx={STYLES.desktop}
            >
              <Select
                value={data[qNo][index] || ""}
                onChange={(ev) => handleChange(ev, qNo, index)}
              >
                <MenuItem value="">Clear</MenuItem>
                <MenuItem value={`${level}-yes`}>Yes</MenuItem>
                <MenuItem value={`${level}-no`}>No</MenuItem>
                <MenuItem value={`${level}-na`}>NA</MenuItem>
              </Select>
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
};

export default QuestionGrid;